<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade" [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="main">
    <div class="col-12">
        <h4 class="title-color">{{ 'setting.agent_dispatch_configuration' | translate }}</h4>
        <hr>
        <div class="row">
            <div class="col-12">
                <fieldset>
                    <form class="w-100" [formGroup]="agentDispatchConfigurationForm" (ngSubmit)="setAgentDispatchConfiguration()" name="form">
                        <div class="row">
                            <div class="col-6">
                                <h5>{{'general.ratio' | translate}}</h5>
                                <input type="number" min="1" step="1" max="100" value="100" id="DispatchRatio" formControlName="DispatchRatio">
                                <ng-container *ngIf="agentDispatchConfigurationForm.get('DispatchRatio').invalid && (formSubmitted || agentDispatchConfigurationForm.get('DispatchRatio').touched || agentDispatchConfigurationForm.get('DispatchRatio').dirty)">
                                    <div *ngIf="agentDispatchConfigurationForm.get('DispatchRatio').hasError('required')"  class="error align-left">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="agentDispatchConfigurationForm.get('DispatchRatio').hasError('pattern')"  class="error align-left">
                                        {{'error.ratio' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-6">
                                <h5>{{'general.attend_limit' | translate}}</h5>
                                <input type="number" min="5" step="1" max="60" value="15" id="AttendRejectTime" formControlName="AttendRejectTime">
                                <ng-container *ngIf="agentDispatchConfigurationForm.get('AttendRejectTime').invalid && (formSubmitted || agentDispatchConfigurationForm.get('AttendRejectTime').touched || agentDispatchConfigurationForm.get('AttendRejectTime').dirty)">
                                    <div *ngIf="agentDispatchConfigurationForm.get('AttendRejectTime').hasError('required')"  class="error align-left">
                                        {{'general.required_field' | translate}}
                                    </div>
                                    <div *ngIf="agentDispatchConfigurationForm.get('AttendRejectTime').hasError('pattern')"  class="error align-left">
                                        {{'error.attend_limit' | translate}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <hr>
                        <div class="row mb-2">
                            <div class="col-12 text-right">
                                <button *ngIf="!editing" class="btn btn-blue btn-h-blue" (click)="edit()">
                                    <i class="fa fa-pencil fa-md pr-1"></i> {{'general.edit' | translate}}
                                </button>
                                <button *ngIf="editing" type="button" class="btn btn-red btn-h-red mr-2" (click)="edit()">
                                    {{'general.cancel' | translate}}
                                </button>
                                <button *ngIf="editing" type="submit" class="btn btn-green btn-h-green">
                                    {{'general.update' | translate}}
                                </button>
                            </div>
                        </div>
                    </form>
                </fieldset>
            </div>
        </div>
    </div>
</div>